import React from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import styled from 'styled-components';

import { Icons, MUI } from '@styles';

const LoginForm = (props) => {

  return (
    <Styled.Form onSubmit={props.handleSubmit}>
      {/* Usuario */}
      <MUI.Box display="flex" alignItems="center" height={1 / 3}>
        <MUI.TextFieldIcon
          label={i18n.t('Login.userEnterpriseId')}
          type="text"
          name="userName"
          value={props.values.userName}
          onBlur={props.handleBlur}
          onChange={props.handleChange}
          onInput={() => props.setFieldTouched('userName', true, true)}
          error={Boolean(props.touched.userName && props.errors.userName)}
          InputProps={{ startAdornment: (<Icons.Person />) }}
        />
      </MUI.Box>
      {/* Contraseña */}
      <MUI.Box display="flex" alignItems="center" height={1 / 3}>
        <MUI.TextFieldIcon
          label={i18n.t('Login.password')}
          id="password"
          type={props.showPassword ? 'text' : 'password'}
          name="password"
          value={props.values.password}
          onBlur={props.handleBlur}
          onChange={props.handleChange}
          error={Boolean(props.touched.password && props.errors.password)}
          InputProps={{
            startAdornment: (<Icons.Lock />),
            endAdornment: (
              <span
                style={{ cursor: 'pointer', marginLeft: 8 }}
                onClick={props.handleTogglePassword}
                tabIndex={0}
                role="button"
                aria-label={props.showPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'}
              >
                {props.showPassword ? <Icons.Visibility /> : <Icons.VisibilityOff />}
              </span>
            )
          }}
        />
      </MUI.Box>
      {/* Checkbox & Button */}
      <MUI.Box display="flex" alignItems="center" height={1 / 3}>
        <MUI.Grid container alignItems="center">
          <MUI.Grid item xs={12} sm={6}>
            <MUI.Box display="flex" flexDirection="column">
              <MUI.CheckboxLabel
                label={i18n.t('Login.keepSess')}
                name="keepSession"
                control={
                  <MUI.Checkbox
                    checked={props.values.keepSession}
                    onChange={props.handleChange}
                  />
                }
              />
              {/* <MUI.CheckboxLabel
                label={i18n.t('Login.rememberDevice')}
                name="rememberDevice"
                control={
                  <MUI.Checkbox
                    checked={props.values.rememberDevice}
                    onChange={props.handleChange}
                  />
                }
              /> */}
            </MUI.Box>
          </MUI.Grid>
          <MUI.Grid item xs={12} sm={6}>
            <MUI.ButtonCTA
              type="submit"
              color="primary"
              fullWidth
              disabled={!props.isValid || props.isSubmitting}
              margin="false"
            >
              {i18n.t('Login.enterLogIn')}
            </MUI.ButtonCTA>
          </MUI.Grid>
        </MUI.Grid>
      </MUI.Box>
    </Styled.Form>
  );
};

LoginForm.propTypes = {
  // Formik props.
  values: PropTypes.any,
  errors: PropTypes.any,
  touched: PropTypes.any,
  isValid: PropTypes.bool,
  isSubmitting: PropTypes.bool,
  handleBlur: PropTypes.func,
  handleChange: PropTypes.func,
  handleSubmit: PropTypes.func,
  setFieldTouched: PropTypes.func
};

// *************************************
// STYLED COMPONENTS                               
// *************************************

const Styled = {};

Styled.Form = styled.form`
  height: 100%;
  width: 100%;
`;

export default LoginForm;
